import React from "react";
import "../../../../styles/styles.css";
import { Alert } from "bootstrap";
import { useNavigate } from "react-router-dom";
const Banner = () => {
    const navigate = useNavigate();

  return (
    <>
      <div className="blog-header"></div>
      <div className="development-banner">
        <div className="development-container">
          <span>DEVELOPMENT</span>
          <span>16 March 2023</span>
        </div>
        <span className="title">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod
        </span>
        <span className="description">
          Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris
          nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur.
        </span>
        <button onClick={()=>{navigate('/blogPage')}} className="read-more">Read More</button>
      </div>
    </>
  );
};
export default Banner;
